module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/attribute-group-tree/attribute-group-tree.component.css
// module id = ./src/app/component/attribute-group-tree/attribute-group-tree.component.css
// module chunks = main